export function replaceAll(input: string, search: string, replacement: string) {
  return input.split(search).join(replacement);
}

export function replaceAllComplex(
  input: string,
  replace: { s: string; r: string }[],
) {
  if (input != null && input != undefined && typeof input === 'string') {
    for (let i = 0; i < replace.length; i++) {
      input = replaceAll(input, replace[i].s, replace[i].r);
    }
  }

  return input;
}

export function printDE_Date(date: Date) {
  let day: string | number = date.getDate();
  let month: string | number = date.getMonth() + 1;
  if (String(day).length == 1) day = '0' + day;
  if (String(month).length == 1) month = '0' + month;

  return day + '.' + month + '.' + date.getFullYear();
}

export function splitNumberThousands(input: number): string {
  //debugger;
  let result = '';
  while (input > 1000) {
    let mod = input % 1000;
    let nullPrefix = '';
    if (mod < 100) nullPrefix += '0';
    if (mod < 10) nullPrefix += '0';

    result = '.' + nullPrefix + mod + result;

    input = input - mod;
    input = input / 1000;
  }

  result = input + result;

  return result;
}

export function umcodeURL(input: string) {
  return replaceAllComplex(input, [
    { s: '%AE', r: '%C2%AE' }, //®
    { s: '%BA', r: '%C2%BA' }, //º
    { s: '%BC', r: '%C5%BA' }, //ź
    { s: '%FC', r: '%C3%BC' }, //ü
    { s: '%B6', r: '%C2%B6' }, //¶
    { s: '%F6', r: '%C3%B6' }, //ö
    { s: '%A4', r: '%C2%A4' }, //¤
    { s: '%E4', r: '%C3%A4' }, //ä
    { s: '%9F', r: '%C2%9F' }, //
    { s: '%DF', r: '%C3%9F' }, //ß
    { s: '%DC', r: '%C3%9C' }, //Ü
    { s: '%D6', r: '%C3%96' }, //Ö
    { s: '%C4', r: '%C3%84' }, //Ä
    { s: '%F1', r: '%C3%B1' }, //ñ
    { s: '%E5', r: '%C3%A5' }, //å
    { s: '%FA', r: '%C3%BA' }, //ú
    { s: '%B8', r: '%C2%B8' }, //¸
    { s: '%F8', r: '%C3%B8' }, //ø
    { s: '%B3', r: '%C5%82' }, //ł
    { s: '%F3', r: '%C3%B3' }, //ó
    { s: '%AD', r: '%C2%AD' }, //­
    { s: '%ED', r: '%C3%AD' }, //í
    { s: '%B4', r: '%C2%B4' }, //´
    { s: '%A1', r: '%C2%A1' }, //¡
    { s: '%E1', r: '%C3%A1' }, //á
    { s: '%A9', r: '%C2%A9' }, //©
    { s: '%E9', r: '%C3%A9' }, //é
    { s: '%A8', r: '%C2%A8' }, //¨
    { s: '%E8', r: '%C3%A8' }, //è
    { s: '%AB', r: '%C2%AB' }, //«
    { s: '%BB', r: '%C2%BB' }, //»
    { s: '%AA', r: '%C2%AA' }, //ª
    { s: '%EA', r: '%C3%AA' }, //ê
    { s: '%F4', r: '%C3%B4' }, //ô
    { s: '%A0', r: '%C2%A0' }, //
    { s: '%E0', r: '%C3%A0' }, //à
    { s: '%E2', r: '%C3%A2' }, //â
    { s: '%A7', r: '%C3%A7' }, //§
    { s: '%E7', r: '%C2%A7' }, //ç
    { s: '%97', r: '%C2%97' }, //
    { s: '%D7', r: '%C3%97' }, //×
    { s: '%E3', r: '%C3%A3' }, //ã
    { s: '%BF', r: '%C2%BF' }, //ã
    { s: '%B0', r: '%C2%B0' }, //°
    { s: '%EB', r: '%C3%AB' }, //ë
    { s: '%EF', r: '%C3%AF' }, //ï
    { s: '%EE', r: '%C3%AE' }, //î
    { s: '%B7', r: '%C2%B7' }, //·
    { s: '%E6', r: '%C3%A6' }, //æ
    { s: '%FB', r: '%C3%BB' }, //û
    { s: '%B2', r: '%C2%B2' }, //²
    { s: '%F2', r: '%C3%B2' }, //ò
    { s: '%F0', r: '%C3%B0' }, //ð
    { s: '%96', r: '%C2%96' }, //
    { s: '%FE', r: '%C5%A3' }, //ţ
    { s: '%99', r: '%C2%99' }, //
    { s: '%B5', r: '%C4%BE' }, //ľ
    { s: '%92', r: '%C2%92' }, //
    { s: '%F5', r: '%C5%91' }, //ő
    { s: '%B9', r: '%C5%A1' }, //š
    { s: '%F9', r: '%C3%B9' }, //ù
    { s: '%BD', r: '%C2%BD' }, //½
    { s: '%FD', r: '%C3%BD' }, //ý
    { s: '%EC', r: '%C3%AC' }, //ì
  ]);
}
